import Vue from 'vue'

import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({

  state: {
    menuList:[],//用户菜单,
    slzt:''//企业受理状态
  },

  mutations: {
    //这里是set方法
   setmenuList(state,Value){
      state.menuList=Value
    },
    setSlzt(state,value){
     state.slzt=value
    }
  },

  getters: {
    //这里是get方法 
    getmenuList:state =>state.menuList,
  },
    actions: {

      //这个部分我暂时用不上

    },
    modules: {
//这里是我自己理解的是为了给全局变量分组，所以需要写提前声明其他store文件，然后引入这里

    }

})



// WEBPACK FOOTER //
// ./src/store/store.js